mutation updateTestimonial($id: ID!, $publicImage: String) {
    updatePixAPicTestimonial(id: $id, publicImage: $publicImage) {
        __typename
        id
        publicImage
        publicImageUrl
    }
}